import { Outlet } from 'react-router-dom';
import React from 'react';
import NavUser from '../../components/pgi/navs/NavUser';
import NavBarPgi from '../../components/pgi/navs/NavBarPgi';

const LayoutPgi = () => {
  return (
    <>
    <NavUser/>
    <div id='wrapperPgi'>
    <Outlet />
    <NavBarPgi  id="navBarPgi"/>
    </div>
    </>
  )
}

export default LayoutPgi